import {
    fetchMyPromoCampaigns,
    fetchPromoCampaign,
    fetchPromoCampaigns,
} from '../queries/promoCampaigns.queries';

import { useQuery } from '@tanstack/react-query';

export const usePromoCampaigns = () => {
    return useQuery({
        queryKey: ['promoCampaigns'],
        queryFn: fetchPromoCampaigns,
    });
};

export const usePromoCampaign = (id: number) => {
    return useQuery({
        queryKey: ['promoCampaign', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchPromoCampaign(id);
        },
    });
};

export const useMyPromoCampaigns = () => {
    return useQuery({
        queryKey: ['myPromoCampaigns'],
        queryFn: fetchMyPromoCampaigns,
    });
};
